import * as Sentry from '@sentry/browser';

window.Sentry = Sentry;
